import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingInlineStart: theme.spacing(2.5),
    boxSizing: 'border-box',
    '& ul': {
      margin: 0,
      padding: 0,
    },
  },
  moreContainer: {
    marginTop: theme.spacing(1),
  },
  more: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  moreButton: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  list: {
    border: `1px solid #e5e6e7`,
    borderRadius: 5,
    margin: 0,
  },
  info: {
    backgroundColor: '#eef1f5',
    border: 'solid 1px rgba(109, 114, 120, 0.18)',
    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },
  titleBox: {
    background: '#eef1f5',
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    boxSizing: 'border-box',
    marginBottom: 0,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  titleArrow: {
    color: '#b9c3ca',
    fontSize: 20,
  },
  listItem: {
    borderTop: `1px solid #e5e6e7`,
    marginTop: 0,
    minHeight: 52,
    textAlign: 'left',
    fontFamily: 'Vazir',
    '& span': {
      fontFamily: 'Vazir !important',
    },
    '&.odd': {
      background: '#f9f9f9',
    },
  },
}));